// /src/Utils/ConsoleLogger.js :
const disableVerboseConsoleInProd = () => {
  if (process.env.NODE_ENV !== 'production') return;

  const noop = () => {};
  const methodsToMute = ['log', 'debug', 'info', 'trace'];

  methodsToMute.forEach((method) => {
    if (typeof console[method] === 'function') {
      console[method] = noop;
    }
  });
};

export default disableVerboseConsoleInProd;